module.exports = __webpack_public_path__ + "img/pgtonegado.2be22771.svg";